import { PaidAccount } from './types';

/**
 * Check if a paid account is about to expire. Can be determined
 * when the expirationDates object on the paidAccount contains
 * a key that matches the product code
 */
export function willExpire(
  paidAccount?: Pick<PaidAccount, 'products' | 'expirationDates'>,
) {
  return (
    paidAccount?.products &&
    paidAccount?.products?.[0] in (paidAccount?.expirationDates ?? {})
  );
}
